import React, { useEffect, useState } from 'react'
import useLogout from '../../hooks/useLogout';
import { toast } from 'react-toastify';
import { getAppointmentListAPI } from '../../api/master/indes';
import Head from '../../layout/head/Head';
import Content from '../../layout/content/Content';
import { Block } from '../../components/Component';
import MyDataTable from '../../MyComp/UI/DataTable/MyDataTable';
import { Badge } from 'reactstrap';

const Appointments = () => { 
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([
    {
      name: "Patient Name",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Gender",
      selector: (row) => <span className="text-capitalize">{row?.gender}</span>,
      sortable: true,
    },
    {
      name: "Patient Mobile",
      selector: (row) => row?.mobile,
      sortable: true,
    },
    {
      name: "Doctor Name",
      selector: (row) => row?.doctor_name,
      sortable: true,
    },
    // {
    //   name: "Disease",
    //   selector: (row) => {
    //     let diseases = [];
    //     try {
    //       diseases =  (row?.disease || "[]");
    //     } catch (e) {
    //       console.error("Invalid JSON in disease field", e);
    //     }

    //     return (
    //       <>
    //         {diseases?.map((item, index) => (
    //           <Badge key={index} className="me-1 my-1" color="outline-primary">
    //             {item}
    //           </Badge>
    //         ))}
    //       </>
    //     );
    //   },
    //   sortable: true,
    //   width: "210px",
    //   wrap: true,
    // },
    {
      name: "Appointment Type",
      selector: (row) => (
        <>
          {row?.type == "book_consultation" ? (
            <Badge color="outline-info">{"Book Consultation"}</Badge>
          ) : row?.type == "walkin" ? (
            <Badge color="outline-gray">{"WalkIn"}</Badge>
          ) : row?.type == "book_appointment" ? (
            <Badge color="outline-secondary">{"Book Appointment"}</Badge>
          ) : null}
        </>
      ),
      sortable: true,
      width:"220px"
    },
    {
      name: "Appointment Status",
      selector: (row) => (
        <>
          <Badge
            className="text-capitalize"
            color={`${
              row?.status == "started"
                ? "outline-secondary"
                : row?.status == "completed"
                ? "outline-primary"
                : row?.status == "cancelled"
                ? "outline-danger"
                : "outline-warning"
            }`}
          >
            {row?.status}
          </Badge>
        </>
      ),
      sortable: true,
    },
    {
      name: "Slot Date",
      selector: (row) => row?.slot_date,
      sortable: true,
      width: "150px",
    },
    {
      name: "Slot Time",
      selector: (row) => row?.slot_time,
      sortable: true,
      width: "150px",
    },
  ]);
  const logout = useLogout();
  useEffect(() => {
    getAppointmentList();
  }, []);
  const getAppointmentList = () => {
    getAppointmentListAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  
    
  return (
    <>
    <Head title="Appointment List"/>
    <Content>
        <Block>
            <MyDataTable
            title="Appointment List"
            isLoading={loading}
            data={data}
            columns={columns}
            />



        </Block>
    </Content>
    
    </>
  )
}

export default Appointments